<template>
  <genre-list
    class="area-genres"
    :allGenresSelected="allAreasSelected"
    :genreList="areas"
    :isGenreSelected="isAreaSelected"
    @allGenresToggled="allAreasToggled"
    @genreToggled="areaToggled"
  ></genre-list>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GenreList from "./GenreList";

export default {
  methods: {
    ...mapActions("search", [
      "allAreasToggled",
      "areaToggled"
    ])
  },

  computed: {
    ...mapGetters("search", ["allAreasSelected", "areas", "isAreaSelected"])
  },

  components: {
    GenreList
  }
}
</script>

<style src="./AreaRefine.scss" lang="scss"></style>
